import React, { useState } from "react";
import warningIcon from "../assets/icons/Warning.png";

const DisclaimerPopup = ({ onAccept }) => {

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 9999 }}
    >
      <div
        className="bg-white rounded-4 shadow-lg p-4"
        style={{ maxWidth: "768px", width: "90%", position: "relative" }}
      >
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h4 className="fw-bold mb-1">Disclaimer</h4>
            <p className="text-muted mb-4">Please read the disclaimer to proceed</p>
          </div>
          <div>
            <img
              src={warningIcon}
              alt="warning"
              style={{ width: "76px", height: "65px" }}
            />
          </div>
        </div>

        <div className="text-dark" style={{ fontSize: "15px" }}>
          <div className="mb-3">
            <strong>1. Image Ownership:</strong>
            <p className="mb-0">
              By uploading any images to this platform, you affirm that you are the rightful owner
              of the image or have obtained the necessary permissions or licenses to use, modify,
              and distribute the image. You are responsible for ensuring that you have the legal
              right to use any images you upload.
            </p>
          </div>

          <div className="mb-3">
            <strong>2. Prohibited Content:</strong>
            <ul className="mb-0">
              <li>Violate any applicable laws, including copyright, trademark, and IP rights.</li>
              <li>
                Contain harmful, illegal, or offensive content (e.g., pornography, hate speech,
                violence, or discrimination).
              </li>
              <li>Promote, encourage, or engage in illegal activities.</li>
            </ul>
          </div>

          <div className="mb-3">
            <strong>3. Accuracy and Responsibility:</strong>
            <p className="mb-0">
              While efforts are made to provide accurate and high-quality image generation services,
              the platform does not guarantee the accuracy, legality, or suitability of any images
              produced or uploaded. Users are solely responsible for the use of the images,
              including but not limited to verifying their accuracy and ensuring they comply with
              all applicable laws and regulations.
            </p>
          </div>

          <div>
            <strong>4. Use of Uploaded Images:</strong>
            <p className="mb-0">
              By uploading images to the platform, users grant the platform a limited,
              non-exclusive, royalty-free license to process, store, and use the images for the
              purposes of providing services related to image generation, modification, and any
              other related functionalities.
            </p>
          </div>
        </div>

        <div className="text-center mt-4">
          <button
            className="btn btn-dark px-5 py-2 rounded"
            // disabled={!isChecked}
            onClick={onAccept}
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPopup;


// import React, { useEffect, useState } from "react";
// import api from '../api';
// import warningIcon from "../assets/icons/Warning.png";

// const DisclaimerPopup = ({ onAccept }) => {
//   const [disclaimer, setDisclaimer] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem("access_token");

//   // ✅ Fetch disclaimer from API
//   useEffect(() => {
//     const fetchDisclaimer = async () => {
//       try {
//         const response = await api.get(
//           `${process.env.REACT_APP_API_URL}/enterprise-disclaimer/my-disclaimer`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         setDisclaimer(response.data.disclaimer || null);
//       } catch (error) {
//         console.error("Error fetching disclaimer:", error);
//         setDisclaimer(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDisclaimer();
//   }, [token]);

//   if (loading) {
//     return null; // or you can show a loader
//   }

//   // ✅ If no disclaimer available, don't show popup
//   if (!disclaimer) return null;

//   return (
//     <div
//       className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
//       style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 9999 }}
//     >
//       <div
//         className="bg-white rounded-4 shadow-lg p-4"
//         style={{ maxWidth: "768px", width: "90%", position: "relative" }}
//       >
//         {/* Header */}
//         <div className="d-flex justify-content-between align-items-start">
//           <div>
//             <h4 className="fw-bold mb-1">
//               {disclaimer.enterprise_disclaimer_title || "Disclaimer"}
//             </h4>
//             <p className="text-muted mb-4">
//               {disclaimer.enterprise_disclaimer_display_location ||
//                 "Please read the disclaimer to proceed"}
//             </p>
//           </div>
//           <div>
//             <img
//               src={warningIcon}
//               alt="warning"
//               style={{ width: "76px", height: "65px" }}
//             />
//           </div>
//         </div>

//         {/* Disclaimer Content */}
//         <div
//           className="text-dark"
//           style={{
//             fontSize: "15px",
//             maxHeight: "400px",
//             overflowY: "auto",
//           }}
//           dangerouslySetInnerHTML={{
//             __html: disclaimer.enterprise_disclaimer_description,
//           }}
//         ></div>

//         {/* Accept Button */}
//         <div className="text-center mt-4">
//           <button
//             className="btn btn-dark px-5 py-2 rounded"
//             onClick={onAccept}
//           >
//             I Understand
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DisclaimerPopup;
